import React from 'react';
import { Grid, Text, Heading, Box } from 'theme-ui';
import PrimaryExpertMedia from './Media';

type Props = {
  expert: Queries.ActivityExpertFragment;
  numberOfExperts: number;
  backgroundColor: string;
};

const PrimaryExpert = ({ expert, numberOfExperts, backgroundColor }: Props) => {
  const { athleteName, description, image, quote, tagline, video } = expert;
  return (
    <Box
      sx={{
        backgroundColor,
        width: '100%',
        gridArea: 'primaryExpert',
      }}
    >
      <Grid
        sx={{
          px: ['2.4rem', '8rem'],
          pt: ['6.4rem', '8rem'],
          maxWidth: 'var(--max-width)',
          mx: 'auto',
          pb: ['8rem', numberOfExperts === 1 ? '8rem' : 0],
          mb: 0,
          columnGap: [0, '4.8rem', '8rem'],
          rowGap: [0, '1.6rem'],
          gridTemplateRows: 'repeat(3, auto) 1fr',
          gridTemplateColumns: ['1fr', '4.1fr 5.8fr', '4.75fr 5.25fr'],
          gridTemplateAreas: [
            `
      "tagline"
      "athleteName"
      "description"
      "quote"
      "image"
      `,
            `
      "tagline tagline"
      "athleteName athleteName"
      "description quote"
      "image image" 
      `,
            `
          "image tagline" 
      "image athleteName"
      "image description"
      "image quote"
      `,
          ],
        }}
      >
        <Text sx={{ gridArea: 'tagline', fontSize: '1.6rem', lineHeight: 1.3, mt: [0, null, '4rem'] }}>{tagline}</Text>
        <Heading variant="text.h4" sx={{ gridArea: 'athleteName' }}>
          {athleteName}
        </Heading>
        {Boolean(description) && (
          <Text
            as="div"
            variant="text.paragraphMain"
            sx={{ gridArea: 'description', p: { m: 0 }, maxWidth: '553px', mb: ['4rem', null, '4.8rem'] }}
            dangerouslySetInnerHTML={{ __html: description?.childMarkdownRemark?.html ?? '' }}
          />
        )}
        {Boolean(quote) && (
          <Text
            as="div"
            variant="text.quotePrimary"
            sx={{
              gridArea: 'quote',
              p: { m: 0 },
              maxWidth: '553px',
              mb: ['4rem', null, '6rem'],
            }}
            dangerouslySetInnerHTML={{ __html: quote?.childMarkdownRemark?.html ?? '' }}
          />
        )}

        <PrimaryExpertMedia image={image} video={video} accentColor={backgroundColor} />
      </Grid>
    </Box>
  );
};

export default PrimaryExpert;
